var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('content-header',{attrs:{"freezer":true}}),_c('div',{staticClass:"content-wrapper"},[_c('el-row',[_c('el-col',{staticClass:"content-right",attrs:{"span":24}},[_c('cooler-list',{attrs:{"type":_vm.tradeType}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }